import React from "react";
import { useTranslation } from "react-i18next";
import Batch from "./Batch";
import "@progress/kendo-react-intl";
import { BatchGroupModel } from "../services/BatchServices";
import { TabStripTabCustom } from "./TabStripTabCustom";
import { SvgIcon } from "@progress/kendo-react-common";
import { folderIcon, aggregateFieldsIcon } from "@progress/kendo-svg-icons";
import { TabStripCustom, TabStripSelectEventArgumentsCustom } from "./TabStripCustom";



export interface BatchGroupProps {
    BatchGroups?: BatchGroupModel[];
    onTabSelect: (groupId: string) => void;
    onReleaseBatch: () => void;
}

const BatchGroup: React.FC<BatchGroupProps> = (props) => {
  const { t } = useTranslation();
  const [selected, setSelected] = React.useState<number>(0);
 

  const handleSelect =(e: TabStripSelectEventArgumentsCustom)=> {
    setSelected(e.selected);
    props.onTabSelect(e.groupId);
  }

  const groupTitle = (group : BatchGroupModel) => (
    <div>
      {group.Name}
      <span style={{ marginLeft: 8 }}>(</span>
      <span
        style={{ marginRight: 8 }}
        title={t("dataLabeling.dashboard.batchesNumberToolTip")}
      >
        <SvgIcon icon={folderIcon} />
        {group.NumberOfItems}
      </span>
      &nbsp;-&nbsp;
      <span
        style={{ marginLeft: 8 }}
        title={t("dataLabeling.dashboard.documentsNumberToolTip")}
      >
        <SvgIcon icon={aggregateFieldsIcon} />
        {group.NumberOfDocuments}
      </span>
      )
    </div>
  )

  return (
    <div className="batch-group">
      <TabStripCustom       
        tabPosition="left"
        selected={selected}
        onSelectCustom={handleSelect}                              
      >
        {props.BatchGroups?.map((group) => (          
          <TabStripTabCustom title={groupTitle(group)} key={group.GroupId} contentClassName="batch-tab" dataGroupId={group.GroupId}>
            <div>
              {group.Batches.map((batch) => (
                <Batch                  
                  key={batch.Id}
                  Id = {batch.Id}
                  Title={batch.Title}
                  Total={batch.Total}
                  Subtitle={batch.Subtitle}
                  Date={batch.Date}
                  ShowButtonRelease={batch.ShowButtonRelease}
                  ShowButtonResume={batch.ShowButtonResume}
                  ShowButtonStart={batch.ShowButtonStart}
                  SourceTypeId={group.GroupId}
                  onReleaseBatch={props.onReleaseBatch}
                  ChannelDescription={batch.ChannelDescription}
                  />
              ))}
            </div>
          </TabStripTabCustom>
        
        ))}        
      </TabStripCustom>
    </div>
  );
};

export default BatchGroup;